module.exports = __webpack_public_path__ + "static/krasia-indihome-d7b39829b88e91c4ea3014248a44b946.jpg";